import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-specification-painel',
  templateUrl: './specification-painel.component.html',
  styleUrls: ['./specification-painel.component.scss']
})
export class SpecificationPainelComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  total: number;

  @Input()
  error: boolean;

  CLOSURES = CLOSURES;

  constructor() { }

  ngOnInit(): void {
  }

}

const CLOSURES = {
  'Optical Closure': $localize`Optical Closure`,
  'Optical Termination Closure': $localize`Optical Termination Closure`,
  'External Closure for Connection to Building': $localize`External Closure for Connection to Building`
};
